import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({
  selector: `[formControl]`
})
export class FormControlWithElementDirective implements OnChanges {
  @Input('formControl') formControl: AbstractControl;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges() {
    (<any>this.formControl).nativeElement = this.elementRef.nativeElement;
  }
}
